import { render, staticRenderFns } from "./howToReplenishBalance.vue?vue&type=template&id=4b086827&scoped=true"
import script from "./howToReplenishBalance.vue?vue&type=script&lang=js"
export * from "./howToReplenishBalance.vue?vue&type=script&lang=js"
import style0 from "./howToReplenishBalance.vue?vue&type=style&index=0&id=4b086827&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b086827",
  null
  
)

export default component.exports